<template>
  <div id="app">
    <nyd-navbar :type="mode" />
    <router-view />
    <template>
      <nyd-footer :visible="mode === 'screen' ? true : false" />
    </template>
  </div>
</template>

<style lang="scss">
body,
#app {
  min-width: 1500px;
}
#app {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
}
</style>

<script>
import NydNavbar from '@/components/NydNavbar';
import NydFooter from '@/components/NydFooter';

export default {
  components: { NydNavbar, NydFooter },
  data() {
    return {
      mode: undefined,
    }
  },
  created() {
    this.mode = (this.$route.path === '/column' || this.$route.path === '/article') ? 'plain' : 'screen';
  },
  watch: {
    '$route.path': function (val) {
      console.log('val', val)
      this.mode = val === '/column' ? 'plain' : 'screen';
    }
  }
}
</script>
